export const borderRadius = {
  xxs: "0rem", // 0px
  xs: "0.125rem", // 2px
  sm: "0.25rem", // 4px
  md: "0.5rem", // 8px
  lg: "1rem", // 16px
  xl: "1.5rem", // 24px
  xxl: "2rem", // 32px
  full: "6.25rem", // 100px
} as const
